import React, { useEffect, useState } from 'react';

// ImageFrame.jsx
// Default export a single React component that shows an image plus
// a date input and a text input. Uses Tailwind CSS for quick styling.

export default function ModalShowPictureAndInput(props) {
  const { data, featureButton1, featureButton2 } = props;
  const { link, title } = data;
  const [date, setDate] = useState('');
  const [note, setNote] = useState('');

  useEffect(() => {
    setNote(data.note)
    setDate(data.date)
  },[data.date, data.note])

  return (
    <div className="max-w-xl mx-auto p-4 bg-white rounded-2xl shadow-md">
      <h2 className="text-xl font-semibold mb-3">{title}</h2>

      <div className="grid grid-cols-1 gap-4">
        {/* Image preview */}
        <div className="border rounded-lg overflow-hidden bg-gray-50">
            <img
              src={`https://database.azumayareport.com/${link}`}
              alt="preview"
               style={{
                width: 250,
                height: "320px",
                objectFit: "cover",
                borderRadius: "6px",
                }}
              className="w-full h-64 object-cover"
            />
        </div>

        {/* Date input */}
        <div className="flex flex-col">
          <label className="text-sm font-medium mb-1">Date</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="border rounded-md p-2"
          />
        </div>

        {/* Text input */}
        <div className="flex flex-col">
          <label className="text-md font-medium mb-1">Note:</label>
          <input
            type="text"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Input text..."
            className="border rounded-md p-2"
          />
        </div>

        {/* Buttons + preview saved values */}
        <div className="flex items-center justify-between gap-4 mt-2">
          <button
            onClick={() => featureButton1(date, note)}
            className="px-4 py-2 rounded-lg shadow-sm border hover:bg-gray-100 btn btn-primary"
          > Save </button>

          <button
            onClick={featureButton2}
            className="px-4 py-2 rounded-lg shadow-sm border hover:bg-gray-100 btn btn-danger"
          > Close </button>

        </div>
      </div>
    </div>
  );
}
